import { useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'


import './favoritos.css'

export default function Favoritos(){
    const [filmes, setFilmes] = useState([]);

    useEffect(()=>{

        const minhaLista = localStorage.getItem('filmes')
        setFilmes(JSON.parse(minhaLista) || [] )

    }, [])


     function handleDelete(id){
        let filtroFilmes = filmes.filter((item)=>{
            return(item.id !== id)
        })

        setFilmes(filtroFilmes)
        localStorage.setItem('filmes', JSON.stringify(filtroFilmes))
        toast.success('Filme excluido com sucesso!!')
    }

        
        return(
            <div id='meus-filmes'>
                <h2> Lista de Favoritos </h2>

                {filmes.length === 0 && <span> Voçê não possui filmes salvos... </span>}

            <ul className='listaFavoritos'>
                {filmes.map((item)=>{
                    return(
                        <li >
                            <div className='liLista'>
                                    <div className='nome'>
                                        <span >{item.nome} </span>
                                    </div>
                                
                                    <div className='links'>
                                        <Link to={`./filme/${item.id}`}> Ver detalhes </Link>
                                        <button onClick={() => handleDelete(item.id)}> Excluir </button>
                                    </div>
                            </div>
                            
                        </li>
                    )
                })}
            </ul>


            </div>
        )
}